import axios from 'axios';

const AUTH_ENDPOINTS = [
    'auth/signin',
    'auth/signout',
    'auth/oauth2',
    'auth/signup',
    'auth/passwordReset',
];

let isRedirecting = false;

function isAuthEndpoint(url: string | undefined): boolean {
    if (!url) return false;
    return AUTH_ENDPOINTS.some((endpoint) => url.includes(endpoint));
}

export function setupSessionInterceptor(): void {
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (
                error.response?.status === 401 &&
                !isRedirecting &&
                !isAuthEndpoint(error.config?.url)
            ) {
                isRedirecting = true;
                localStorage.removeItem('userProfile');
                localStorage.removeItem('eimMode');
                window.location.href = '/isam/react/signin';
            }
            return Promise.reject(error);
        }
    );
}
